/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { Button, Divider, Empty } from 'antd';

import Content from '../../content';
import { GetIcon } from 'datastake-daf/dist/components';
import i18next from 'i18next';

export default function FormPreview({
  form = {},
  data = {},
  linkingData = {},
  linkingForms = {},
  onEdit = () => { },
  canEdit,
}) {
  const formContent = useRef();
  const defaultKey = Object.keys(form).find(k => form[k].position === 0);
  const { label, ...config } = defaultKey === 'identification' ? form[defaultKey] : {};
  const [collapsed, setCollapsed] = useState(true);
  const [formContentStyle, setFormContentStyle] = useState({
    maxHeight: '465px',
    overflow: 'hidden',
  });
  const [hasViewMore, setHasViewMore] = useState(true);

  const observer = useRef(new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      const { height } = entries[0].contentRect;
      if (height < 465) {
        setHasViewMore(false);
      } else {
        setHasViewMore(true);
      }
    });
  }));

  useEffect(() => {
    if (formContent && formContent.current) {
      observer.current.observe(formContent.current);
    }
  }, [formContent.current, observer]);

  useEffect(() => {
    if (collapsed) {
      setFormContentStyle({
        maxHeight: collapsed && hasViewMore ? '465px' : 'auto',
        overflow: collapsed && hasViewMore ? 'hidden' : 'auto'
      });
    } else {
      setFormContentStyle({
        height: 'auto',
        overflow: 'auto'
      });
    }
    if (formContent.current) {
      formContent.current.scrollTo(0, 0);
    }
  }, [collapsed]);

  return defaultKey === 'identification' ? (
    <div className="formPreview risk-widget">
      <div className="risk-identification-head">
        <h1 className="risk-header">{label}</h1>
        {canEdit ? <Button
          type="link"
          icon={<GetIcon icon="FormOutlined" />}
          onClick={onEdit}>
          {i18next.t('Edit')}
        </Button>
          : null}
      </div>
      <div ref={formContent} style={formContentStyle}>
        <Content
          linkingData={linkingData}
          form={config}
          data={data || {}}
          linkingForms={linkingForms}
          ajaxOptions={[]}>
        </Content>
      </div>
      {hasViewMore && <Divider
        plain
        onClick={() => setCollapsed(!collapsed)}>
        <GetIcon icon={collapsed ? "DownOutlined" : "UpOutlined"} />
        {i18next.t(collapsed ? 'View More' : 'View Less')}
      </Divider>}
    </div>
  ) : <div className="formPreview">
    <div className="head">
      <div>
        <GetIcon icon="list-ordered" size="2x" />
        <h1>{i18next.t('Identification')}</h1>
      </div>
      <Button
        type="link"
        icon={<GetIcon icon="FormOutlined" />}
        onClick={onEdit}>
        {i18next.t('Edit')}
      </Button>
    </div>
    <div className="content">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </div>
  </div>;
}
